import myzxios from '../utils/myaxios'

export function queryFeedbackList(data){
    return myzxios({
        url: '/manager/feedback/findFeedbackInfo',
        params: data
    })
}

export function submitReplyInfo(data){
    return myzxios({
        url: '/manager/feedback/submitReply',
        data,
        method:'post'
    })
}